import React from "react";

const ICONS = {
  facebook: "fab fa-facebook-f",
  instagram: "fab fa-instagram",
  youtube: "fab fa-youtube",
  x: "fab fa-x",
};

/**
 * Social icons from siteConfig.social (order = object order).
 * Empty URL keeps the icon (as on the original site) with a "#" placeholder link.
 */
const SocialIcons = ({ social = {}, className = "social-icons list-unstyled mb-0" }) => {
  const links = Object.entries(social).filter(([key]) => ICONS[key]);
  if (!links.length) return null;
  return (
    <ul className={className}>
      {links.map(([key, url]) => (
        <li key={key}>
          <a href={url || "#"} {...(url ? { target: "_blank", rel: "noopener noreferrer" } : {})} aria-label={key}>
            <i className={ICONS[key]}></i>
          </a>
        </li>
      ))}
    </ul>
  );
};

export default SocialIcons;
